import classNames from 'classnames';

export const BgRadialBlur = ({ color = 'porange' }) => {
    return (
        <div
            className={classNames({
                'bg-orange-600': color === 'orange',
                'bg-porange-900': color === 'porange',
                'rounded-full': true,
                'size-[26rem] xs:size-[32rem] md:size-[50rem]': true,
                '-top-20 xs:-top-30 md:-top-[500px]': true,
                'md:inset-x-0 md:m-auto': true,
                'absolute opacity-35 blur-3xl z-10': true,
            })}
        />
    );
};